let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h08cQ")).then(() => parcelRequire('2xy9y'));